<template>
    <div class="vehicle-details">
        <div v-if="vehicle">
            <img
                class="vehicle-details__image"
                v-if="vehicle.image"
                :src="vehicle.image"
                alt="Car Image"
            />
            <div class="vehicle-details__image-text">
                Image for illustrative purposes only
            </div>
            <div class="vehicle-details__wrapper">
                <h3 class="vehicle-details__heading">Your vehicle details</h3>

                <div class="vehicle-details">
                    <div class="vehicle-details__detail-item">
                        <span>Make: </span>{{ vehicle.make }}
                    </div>
                    <div class="vehicle-details__detail-item">
                        <span>Model: </span>{{ vehicle.model }}
                    </div>
                    <div class="vehicle-details__detail-item">
                        <span>Bodystyle: </span>{{ vehicle.bodystyle }}
                    </div>
                    <div class="vehicle-details__detail-item">
                        <span>Derivative: </span>{{ vehicle.derivative }}
                    </div>
                    <div class="vehicle-details__detail-item">
                        <span>Engine size: </span>{{ vehicle.engineSize }} cc
                    </div>
                    <div class="vehicle-details__detail-item">
                        <span>Fuel type: </span>{{ vehicle.fuelType }}
                    </div>
                    <div class="vehicle-details__detail-item">
                        <span>Transmission: </span>{{ vehicle.transmission }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "VehicleDetails",
    computed: {
        ...mapState(["vehicle"]),
    },
};
</script>

<style lang="scss" scoped>
.vehicle-details {
    &__image {
        max-width: 100%;
    }

    &__image-text {
        text-align: center;
        margin-bottom: 20px;
    }

    &__wrapper {
        background-color: #e5f4fa;
        border-radius: 10px;
        padding: 15px;
    }

    &__heading {
        color: #192a44;
        margin-bottom: 10px;
        font-weight: 700;
        font-size: 20px;
        line-height: 20px;
    }

    &__detail-item {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;

        & > span {
            font-weight: bold;
        }

        & + & {
            margin-top: 5px;
        }
    }
}
</style>
